angular.module('impactx').factory('themeFactory', [
    '$config',
    '$workspace',
    'cookieService',
    '$context',
    '$mdTheming',
    'ThemeWorldService',
    function($config, $workspace, cookieService, $context, $mdTheming, ThemeWorldService) {
        var generatedThemes = [];

        function generateTheme(themeName) {
            if(generatedThemes.indexOf(themeName) < 0) {
                $mdTheming.generateTheme(themeName);
                generatedThemes.push(themeName);
            }
        }

        return {
            getTheme: function() {
                if($workspace.getHighContrastActive()) {
                    theme = $workspace.getHighContrastKey();
                    generateTheme(theme);
                    return theme;
                }

                var theme = 'shop';
                if(!$workspace.getCurrentWorkspaceId().value && cookieService.getCookieValue("workspaceName" + $context.userId.value)) {
                    theme = cookieService.getCookieValue("workspaceName" + $context.userId.value);
                }
                if($config.configuredThemes.indexOf($workspace.getCurrentWorkspaceId().value) > -1) {
                    theme = $workspace.getCurrentWorkspaceId().value;
                }
                if(ThemeWorldService.getCurrentThemeWorldSearch() && theme === 'shop') {
                    theme = ThemeWorldService.getCurrentThemeWorldSearch();
                } else {
                    theme = theme + $context.getSuffixForTheme();
                }
                generateTheme(theme);

                return theme;
            },
            initializeTheming: function() {
                generateTheme('default');
                generateTheme('shop');
            }
        };
    }
]);